import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import DataTablePagination from '../Tables/DataTablePagination';

import { useAvailableRangesView } from './context/AvailableRangesViewContext';
import AvailableRangeViewCollapsedTable from './components/AvailableRangeViewCollapsedTable';
import AvailableRangesViewExpandedTable from './components/AvailableRangesViewExpandedTable';

const AvailableRangesView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAvailableRangesView();

  const hasData = data.availableRanges?.length > 0;

  return (
    <div key="available-ranges-card">
      <AvailableRangeViewCollapsedTable />

      {data.expandView && <AvailableRangesViewExpandedTable />}

      {hasData && data.expandView && (
        <>
          <DataTablePagination
            currentPage={data.page || 1}
            itemPerPage={data.rowsPerPage || 10}
            totalItems={data.totalAvailableRanges || 0}
            paginate={actions.handleChangePage}
            onChangeRowsPerPage={actions.handleChangeRowsPerPage}
            customItemPerPage={0}
            setRowsPerPage={() => {}}
          />
          <span className="sub-text">
            <i>{t('AvailableSharesInfo')}</i>
          </span>
        </>
      )}
    </div>
  );
};

export default AvailableRangesView;
